import { useMemo } from 'react';

import { Toaster } from 'react-hot-toast';
import { RouterProvider } from 'react-router';

import { QueryClientAppProvider, createCrmRouter } from '@crm/app/providers';
import { setCrmRuntimeConfig } from '@crm/shared/config';

interface IAppProps {
    basename?: string;
    companyId?: string;
    dashboardRoutes?: Record<string, string>;
    tariffPaymentUrl?: string;
}

export const App = ({ basename = '/crm', companyId, dashboardRoutes, tariffPaymentUrl }: IAppProps) => {
    setCrmRuntimeConfig({ companyId, dashboardRoutes, tariffPaymentUrl });

    const router = useMemo(() => createCrmRouter(basename), [basename]);

    return (
        <QueryClientAppProvider>
            <RouterProvider router={router} />
            <Toaster
                toastOptions={{
                    style: {
                        alignItems: 'center',
                        background: '#fff',
                        borderRadius: '12px',
                        boxShadow: '0 8px 24px rgb(15 23 42 / 12%)',
                        color: '#252733',
                        display: 'flex',
                        gap: '8px',
                        lineHeight: 1.3,
                        maxWidth: '350px',
                        minWidth: 'fit-content',
                        padding: '8px 10px',
                    },
                }}
            />
        </QueryClientAppProvider>
    );
};
